<template>
  <div id="MapContent">
    <div id="map-content"></div>
  </div>
</template>

<script>
import 'webix/webix.css'
import 'webix/skins/mini.min.css'

import Map from 'PageGeo/controllers/map'
import SaveWnd from 'PageGeo/controllers/save.wnd'

export default {
  name: 'PageGeo',
  props: {
    areaId: String,
    isCreateMode: Boolean
  },
  data(){
    return {
      Map: {},
      SaveWnd: {}
    }
  },
  async mounted() {
    this.SaveWnd = new SaveWnd({})
    this.Map = new Map({SaveWnd: this.SaveWnd})

    await this.Map.loadMap()

    if(!this.isCreateMode)
    {
      await this.Map.getAreaById(this.areaId)
    }
  },

  beforeDestroy() {
    const elements = document.getElementsByClassName('webix_view webix_layout_line')
    for (const elementsKey of elements) {
      elementsKey.remove()
      break
    }
  }
}


</script>

<style scoped>

</style>
